import { liveUsageResourceMetadataSelector } from "../liveUsageResourceMetadataSelector";
import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";

export const liveUsageResourceMetadataTotalResourcesCountSelector = (
  state: RootState,
  resourceType: ResourceType,
) => {
  return liveUsageResourceMetadataSelector(state, resourceType)
    ?.total_resources_count;
};
